export { default } from './FlowboxWidgetBlock';
